export const handleErrorAlert = (error: any): void => {
  const fields = error?.response?.data?.fields;
  const statusCode = error?.response?.data?.code;
  const messageResponse = error?.response?.data?.message || "Warning";
  const title = statusCode ? `Warning: (${statusCode})` : "Warning";

  if (Array.isArray(fields) && fields.length > 0) {
    const errorMessages = fields.map(f => `• ${f.field}: ${f.errorMessage}`).join("\n");
    window.alert(`${title}\n\n${errorMessages}`);
  } else {
    window.alert(`${title}\n\n${messageResponse}`);
  }
};
